import React, { useEffect, useState } from "react"
import WhatsappIcon from "../../../assets/images/whatsapp-icon.svg"
import ChatIconMenu from "../../../assets/images/chat-icon-menu.svg"
import CloseIconMenu from "../../../assets/images/close-icon-menu.svg"
import WhatsappIconMenu from "../../../assets/images/whatsapp-icon-menu.svg"
import WhatsappStoreIconMenu from "../../../assets/images/whatsappStore-icon-menu.svg"
import ConsultorioIconMenu from "../../../assets/images/consultorio-icon-menu.svg"
import { siteUrl } from "../../../utils/siteUrl"
import useMediaQuery from '../../../utils/useMediaQuery'
import { navigate } from "gatsby"
// import { navigate } from '@reach/router';
import "./modal-chat.scss"
import { encryptUserInfo } from "../../../utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../utils/metricManagementUtil"

const ModalChat = () => {
  const [showModal, SetShowModal] = useState(false)
  const [showText, setShowText] = useState(true)
  const isMobile = useMediaQuery()

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowText(false)
    }, 10000);
    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    if (document.getElementsByClassName("helpButton").length > 0) {
      const element = document.getElementsByClassName("helpButton")
      element[0].style.visibility = showModal ? "visible" : "hidden"
    }
  }, [showModal])

  const redirectWhatsapp = () => {
    const url =
      "https://api.whatsapp.com/send?phone=573233216593&text=%C2%A1Hola!%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%3F%20%0A%0AEn%20este%20chat%20te%20ayudaremos%20a%20responder%20las%20preguntas%20sobre%20la%20marca%20Nosotras%20y%20NosotrasOnline.%20Si%20tienes%20una%20consulta%20para%20nuestra%20ginec%C3%B3loga%20o%20psic%C3%B3loga%20hazla%20aqu%C3%AD%20https%3A%2F%2Fwww.nosotrasonline.com.co%2Fentre-nosotras%2Fconsultorios%2F%0A%0AHorario%20de%20atenci%C3%B3n%20de%20lunes%20a%20viernes%20de%208am%20a%206pm."

    helpDatalayer("whatsapp ayuda")
    window.open(url, "_blank")
    SetShowModal(false)
  }

  const redirectStore = () => {
    const store = "https://api.whatsapp.com/send?phone=573208576801"

    helpDatalayer("whatsapp e-store")
    window.open(store, "_blank")
    SetShowModal(false)
  }

  const redirectConsulting = () => {
    const consultingUrl = siteUrl + "/entre-nosotras/consultorios/"

    helpDatalayer("Consultorios")
    window.location.href = consultingUrl
  }

  const userInfoEncrypt= encryptUserInfo()
  const helpDatalayer = (label) => {
    pushDataLayerEvent({
      event: "Interacciones - Canales de atención",
      category: "canales de atención",
      action: "click",
      label,
      location: window.location.href,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  const Modal = () => {
    return (
      <>
        {showModal && (
          <div className="f-modal-help">
            <div className="f-modal-help__content">
              <button
                onClick={() => SetShowModal(false)}
                className="f-modal-help__content__close"
              >
                <img src={CloseIconMenu} alt="boton cerrar" />
              </button>
              <button
                onClick={() => redirectWhatsapp()}
                className="f-modal-help__content__whatsapp"
              >
                <img src={WhatsappIconMenu} alt="boton whatsapp" />

                <p className="f-modal-help__content__whatsapp__p">
                  Whatsapp <br /> ayuda
                </p>
              </button>
              <button
                onClick={() =>
                  // navigate(siteUrl + '/mis-puntos/que-puedo-ganar/', { replace: true })
                  // window.location.href = siteUrl + "/mis-puntos/que-puedo-ganar/"
                  redirectStore()
                }
                className="f-modal-help__content__whatsappStore"
              >
                <img src={WhatsappStoreIconMenu} alt="whatsapp store" />

                <p className="f-modal-help__content__whatsapp__p">
                  Whatsapp <br /> E-store
                </p>
              </button>
              <button
                onClick={redirectConsulting}
                className="f-modal-help__content__consultorio"
              >
                <img src={ConsultorioIconMenu} alt="consultorio boton" />

                <p className="f-modal-help__content__whatsapp__p">
                  Consultorios
                </p>
              </button>
            </div>
            {/* <div className="f-modal-help__header">
              <h2 className="f-modal-help__header-title">Chat</h2>
              <button
                onClick={() => SetShowModal(false)}
                className="f-modal-help__header-close"
              >
                <span>X</span>
              </button>
            </div>
            <div className="f-modal-help__body">
              <p className="f-modal-help__title">
                ¡Hablemos! ¿Qué medio prefieres?
              </p>

              <div className="f-modal-help__Options">
                <div className="f-modal-help__Options-chat" id="BotonAsesor">
                  <Chat />
                </div>

                <button
                  className="f-modal-help__Options-whatsapp"
                  onClick={() => redirectWhatsapp()}
                >
                  <img src={WhatsappIcon} alt="whatsapp" />
                  <span className="f-modal-help__Options-whatsapp-title">
                    Whatsapp
                  </span>
                </button>
              </div>

              <p className="f-modal-help__description">
                Horario de atención de lunes a viernes de 8am a 6pm.
              </p>
            </div> */}
          </div>
        )}
      </>
    )
  }

  return (
    <>
      <div className="f-btn-help">
        { !isMobile &&
          <div className={`f-btn-help__text ${!showText && 'showNot'}`}>
            <p className="f-btn-help__text__p">Hola , ¿puedo ayudarte?</p>
          </div>
        }
        <button
          onClick={() => {
            pushDataLayerEvent({
              event: "Interacciones - Mis Puntos",
              category: "tranversal",
              action: "click",
              label: "boton_chat",
              Location: window.location.href,
              user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
              log_status: userInfoEncrypt.log_status,
            })

            SetShowModal(true)
          }}
          className="f-btn-help__content"
        >
          {/* <span className="f-btn-help__content-icon" data-icon="" /> */}
          {/* <span className="f-btn-help__content-title">C</span> */}
          <img src={ChatIconMenu} alt="chat icon menu" />
        </button>
      </div>
      <Modal />
    </>
  )
}

export default ModalChat
